import React, { Component } from "react";
import {
  Dropdown,
  Form, 
  Header, 
  Input, 
  TextArea,
  Container
} from "semantic-ui-react";

import request from "../../utils/request";
import ResponseMessage from "../../components/common/ResponseMessage";

const cannedProfile = () => {
  return {
    id: 0,
    title: "",
    content: "",
    created_at: "",
    updated_at: "",
    deleted_at: ""
  };
}

const resetState = () => {
  return {
    isMounted: false,
    isLoading: true,
    xhrStatus: '',
    xhrMessage: '',
    cannedId: 0,
    profile: cannedProfile()
  };
};
class SocialCannedForm extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();
    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.cannedId = id; 
  }
  componentDidMount = () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace("/social/canned");
      return;
    }
    this.setState({ isMounted: true });
    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  fetchData = () => {
    let self = this;
    let promises = [request.get(this, "api:/social/canned", {})];
    if (this.state.cannedId > 0) {
      promises.push(
        request.get(this, `api:/social/canned/${this.state.cannedId}`, {})
      );
    }
    Promise.all(promises).then(function (values) {
      if (values[1]) {
        self.setProfile(values[1]);
      }
      self.setState({ isLoading: false });
    });
  };
  handleChange = (e, { name, value }) => {
    let data = {...this.state.profile};
    data[name] = value;
    this.setState({ profile: data },this.handleMessageChange);
  };
  handleDropdown = (e, {name, value}) => {
    let data = {...this.state.profile};
    let notes = data.content.substring(0, this.state.startIndex) + " " +
    value + " " +
    data.content.substring(this.state.startIndex, data.content.length)
    data['content'] = notes;
    this.setState({
      profile: data
    });
  }
  handleMessageClick = (e) => {
    this.setState({
        startIndex: e.target.selectionStart,
    });
  }
  handleMessageChange = (e) => {
    this.setState({notes: e && e.currentTarget && e.currentTarget.value});
  }
  setProfile = result => {
    let profile = result;
    this.setState({
      profile: profile,
      isLoading: false
    });
  };
  handleSubmit = () => {
    const { profile } = this.state;
    this.setState({
      isLoading: true,
      xhrStatus: '',
      xhrMessage: ''
    });
    let submit;
    if (profile.id > 0) {
      submit = request.put(this, `api:/social/canned/${profile.id}`, profile)
    } else {
      submit = request.post(this, "api:/social/canned", profile)
    }
    submit.then(resp => {
      this.setState({
        xhrStatus: resp.success ? 'success' : 'error',
        xhrMessage: resp.message,
        isLoading: false
      });
      if (resp.success) {
        if (this.state.cannedId === 0) this.setState({ profile: cannedProfile() });
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    })
  };
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      isLoading,
      xhrStatus,
      xhrMessage,
      profile,
    } = this.state;
    const options = [
      { text: "CTA Jackpot", value: '{%%jackpot%%}' },
      { text: "CTA Jackpot Winning Ticket", value: '{%%jackpotTicket%%}' },
      { text: "Weekly Jackpot", value: '{%%prize%%}' },
      { text: "Weekly Jackpot Winning Ticket", value: '{%%prizeTicket%%}' },
      { text: "Event Title", value: '{%%event%%}' },
      { text: "Game Type", value: '{%%game%%}' },
      { text: "Non-Profit", value: '{%%nonprofit%%}' },
      { text: "E-commerce Page", value: '{%%buyUrl%%}' },
      { text: "Contact Page", value: '{%%contactUrl%%}' },
      { text: "Winners Page", value: '{%%winUrl%%' }
    ];
    
    return (
      <Container text>
        <Form
          loading={isLoading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
          <Header as="h4">Title</Header>
          <Input placeholder="Choose a Title" name="title" value={profile.title} onChange={this.handleChange}/>
          <Header as="h4">Message</Header>
          <TextArea
            name="content"
            placeholder="Type in your message"
            value={profile.content}
            onClick={this.handleMessageClick}
            onChange={this.handleChange}
          />
          <br /><br />
          <Dropdown
            placeholder='Choose a custom variable'
            selection
            options={options}
            onChange={this.handleDropdown}
          />
          <Form.Button
            primary
            icon="save"
            content="Save"
            floated="right"
            onClick={this.handleSubmit}
          />
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
      </Container>
    );
  }
}

export default SocialCannedForm;
